import { render, staticRenderFns } from "./giveaway.vue?vue&type=template&id=4e557236&scoped=true"
import script from "./giveaway.vue?vue&type=script&lang=ts"
export * from "./giveaway.vue?vue&type=script&lang=ts"
import style0 from "./giveaway.vue?vue&type=style&index=0&id=4e557236&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e557236",
  null
  
)

export default component.exports